import { useTranslate } from "@similarweb/i18n-provider";

import type { SignalHook } from "app/pages/sales-intelligence/modules/company-analysis/services/signals/signalHooks";
import { SignalUpsellBanner } from "app/pages/sales-intelligence/modules/signals/components/SignalUpsellBanner/SignalUpsellBanner";
import { useSignalAccessRequestSent } from "app/pages/sales-intelligence/modules/signals/hooks/useSignalAccessRequestSent";

type SignalPromoBannerProps = {
    hook: SignalHook;
};

const SignalPromoBanner = ({ hook }: SignalPromoBannerProps) => {
    const { translate } = useTranslate();
    const [isAccessRequestSent, markAccessRequestSent] = useSignalAccessRequestSent(hook.signalType);

    const handleRequestAccess = (): void => {
        hook.requestAccess();
        if (hook.showsRequestSentState) {
            markAccessRequestSent();
        }
    };

    return (
        <SignalUpsellBanner
            signalType={hook.signalType}
            title={translate(hook.bannerTitleKey)}
            description={translate(hook.bannerSubtitleKey)}
            ctaLabel={translate("si.common.upgrade")}
            iconName={hook.iconName}
            iconImagePath={hook.iconImagePath}
            onRequestAccess={handleRequestAccess}
            isRequestSent={Boolean(hook.showsRequestSentState) && isAccessRequestSent}
        />
    );
};

export default SignalPromoBanner;
